export enum StockStatus {
  Active = "ACTIVE",
  Created = "CREATED",
  Inactive = "INACTIVE",
}
